<template>
  <div
    class="form-controls"
    :class="{ 'full-width': fullWidth }"
  >
    <BaseButtonV2
      v-if="!previousHidden && hasSlotPrevious"
      class="justify-start"
      :class="{ 'pl-0': !fullWidth && previousType === 'link' }"
      :color="previousColor"
      :href="previousLink"
      :type="previousType"
      :disabled="previousDisabled"
      :medium="medium"
      :small="small"
      :role="previousType === 'link' ? 'link' : 'button'"
      @click="clickHandler"
    >
      <slot name="previous" />
    </BaseButtonV2>
    <BaseButtonV2
      v-if="!nextHidden && hasSlotNext"
      :type="nextType"
      :disabled="nextDisabled"
      :medium="medium"
      :small="small"
      @click.prevent="$emit('next', $event)"
    >
      <slot name="next" />
    </BaseButtonV2>
  </div>
</template>

<script lang="ts" setup>
import {
  computed, useSlots,
} from 'vue';
import BaseButtonV2 from '@/components/forms/base/BaseButtonV2.vue';

const props = withDefaults(defineProps<{
  previousLink?: string;
  previousColor?: string;
  previousType?: string;
  previousHidden?: boolean;
  previousDisabled?: boolean;
  nextType?: string;
  nextHidden?: boolean;
  nextDisabled?: boolean;
  fullWidth?: boolean;
  medium?: boolean;
  small?: boolean;
}>(), {
  previousLink: '',
  previousColor: 'primary',
  previousType: 'link',
  previousHidden: false,
  previousDisabled: false,
  nextType: 'filled',
  nextHidden: false,
  nextDisabled: false,
  fullWidth: false,
  medium: false,
  small: false,
});

const emit = defineEmits(['previous', 'next']);

const slots = useSlots();

const hasSlotPrevious = computed(() => typeof slots.previous === 'function');
const hasSlotNext = computed(() => typeof slots.next === 'function');

const clickHandler = (e: Event) => {
  if (!props.previousLink) {
    e.preventDefault();
  }

  emit('previous', e);
};
</script>

<style lang="scss" scoped>
.form-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1.875rem;
  justify-content: space-between;

  .base-button {
    flex: 0 0 auto;
    min-width: calc(10em - (1rem / 2));
  }

  &.full-width {
    flex-direction: column;

    .base-button {
      flex: 1 1 auto;
      justify-content: center !important;
    }
  }
}
</style>
